import fetch, { postFrom } from "../utils/fetch";

// 续约意向管理列表
export function getList(data) {
  return fetch({
    method: 'POST',
    url: 'renewagreement/list',
    data
  })
}

// 查看续约意向
export function readRenewIntention(contractId) {
  return fetch({
    method: 'GET',
    url: 'renewagreement/agreementList',
    params: {
      contractId
    }
  })
}

// 修改续约意向 renewagreement/saveEntity
export function updateRenewIntention(data) {
  return fetch({
    method: 'POST',
    url: 'renewagreement/saveEntity',
    data
  })
}

// 获取续约意向下拉框
export function getRenewCondition(state) {
  return fetch({
    method: 'GET',
    url: 'renewagreement/selectCondition',
    params: {
      state
    }
  })
}

// 工作台获取续约意向列表
export function getRenewIntentionList(params) {
  return fetch({
    method: 'POST',
    url: 'renewagreement/getRenewIntentionList',
    data: params
  })
}

// 工作台跟进续约意向
export function saveFollowAgreement(params) {
  return fetch({
    method: 'POST',
    url: 'renewagreement/saveFollowAgreement',
    data: params
  })
}

// 工作台获取续约意向数量
export function getRenewIntentionNum(params) {
  return fetch({
    method: 'GET',
    url: 'renewagreement/getRenewIntentionNum',
    params
  })
}

// 工作台获取续约意向条件
export function getRenewIntentionCondition(params) {
  return fetch({
    method: 'GET',
    url: 'renewagreement/getRenewIntentionCondition',
    params
  })
}

// 工作台获取续约意向条件
export function getRenewIntentionActivityCondition(params) {
  return fetch({
    method: 'GET',
    url: 'renewagreement/getRenewIntentionActivityCondition',
    params
  })
}

// 发送优惠短信
export function sendPreferentialMsg(params) {
  return fetch({
    method: 'POST',
    url: 'renewagreement/sendCollageMsg',
    data: params
  })
}

// 发送优惠短信
export function previewCollageMsg(params) {
  return fetch({
    method: 'POST',
    url: 'renewagreement/previewCollageMsg',
    data: params
  })
}

// 获取正在进行中的活动数量
export function getGroupCount(projectId) {
  return fetch({
    method: 'GET',
    url: 'renewagreement/getGroupCount',
    params: {
      projectId
    }
  })
}
